import { Backdrop } from './Backdrop';
import { MessageBox } from './MessageBox';

export class PrizesMessage {
  private message;
  private backdrop;

  constructor(scene, cancelCallback) {
    this.backdrop = new Backdrop(scene);



    this.message = new MessageBox(
      scene,
      1,
      1,
      [],
      [{ name: 'menuclose', method: this.cancel(cancelCallback), width: 75, height: 75, y: -625, x:-325 }],
      [{ width: 716 * 0.9, height: 961 * 0.6, name: 'prize-table', x: 0.5, y: 0.45 }]

    );
  }

  private cancel = (cancelCallBack) => () => {
    cancelCallBack();
    this.backdrop.destroy();
    this.message.destroy();
  };
}
